const selectors = {
  synchronizedForms: 'data-synchronized-selector'
}
const attributes = {
  synchronizedForms: 'data-synchronized-selector'
}

document.addEventListener('DOMContentLoaded', () => {

  const mainProduct = document.querySelector("form.main-product-form" + `[${selectors.synchronizedForms}]`);
  const synchronizeFormsId = mainProduct.getAttribute(attributes.synchronizedForms);
  if (!mainProduct && synchronizeFormsId) {
    return;
  }
  const flavorProduct = document.querySelector("form.flavours-product-form" + `[${selectors.synchronizedForms}="${synchronizeFormsId}"]`);
  const flavorProductID = parseInt(flavorProduct.getAttribute('data-productId'));

  if (!flavorProduct && flavorProductID) {
    return;
  }

  const observerOptions = {
    childList: true,
    subtree: true
  }
  const observerWhenRechargeAddedToMain = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      mutation.addedNodes.forEach((node) => {
        if (node.classList.contains('rc-container-wrapper')) {
          window.ReChargeWidget.createWidget(config);
          observerWhenRechargeAddedToMain.disconnect()
        }
      })
    });
  });
  observerWhenRechargeAddedToMain.observe(mainProduct, observerOptions);



  const config = {
    productId: flavorProductID, // Required
    injectionParent: flavorProduct, // The node that will have the widget injected in
    injectionMethod: 'prepend', // How will the widget be injected
    injectFn: (node, target) => {
    }, // Runs a custom injection function
    selectors: {
      price: ['.my-price-selector'], // the selectors that will be updated based on subscription
      variant: ['.variant-selector'] // The variants to watch for to update the subscription prices
    }
  };
  const observeWhenRechargeAddedToFlavors = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      mutation.addedNodes.forEach((node) => {
        editInputLabelsInNodeAndDisconnectIfRcContainer(node)
      })

      function editInputLabelsInNodeAndDisconnectIfRcContainer(node) {
        if (node.classList.contains('rc-container-wrapper')) {
          editAllLabelsIds(node);
          editAllInputsId(node);

          function editAllLabelsIds(node) {
            node.querySelectorAll('label').forEach((label) => {
              const forAttr = label.getAttribute('for')
              label.setAttribute('for', forAttr + '-flavor');
            })
          }

          function editAllInputsId(node) {
            node.querySelectorAll('input').forEach((input) => {
              const idAttr = input.id;
              input.setAttribute('id', idAttr + '-flavor');
            })
          }

          observeWhenRechargeAddedToFlavors.disconnect()
        }
      }
    });
  });

  observeWhenRechargeAddedToFlavors.observe(flavorProduct, observerOptions);
});
